export class UserDetails {
  constructor(public  name?: string,
              public lastName?: string,
              public email?: string,
              public password?: string,
              public companyName?: string) {
  }
}
